import React, { Component } from "react";
import { connect } from "react-redux";

import ListEcartReddition from "../../components/ListEcartReddition";
import { columns } from "./columns";

import { loadProprietaires } from "../../store/actions/proprietaireAction";
import { loadLocations } from "../../store/actions/locationAction";
import { loadQuittances } from "../../store/actions/quittanceAction";
import { loadReglements } from "../../store/actions/reglementAction";
import { loadEcritures } from "../../store/actions/ecritureAction";

class EcartReddition extends Component {
  componentDidMount() {
    Promise.all([
      !this.props.proprietaires && this.props.loadProprietaires(),
      !this.props.locations && this.props.loadLocations(),
      !this.props.quittances && this.props.loadQuittances(),
      !this.props.reglements && this.props.loadReglements(),
      !this.props.ecritures && this.props.loadEcritures(),
    ]);
  }

  render() {
    const { utilisateur, proprietaires, locations, quittances, reglements, ecritures, report } =
      this.props;

    // Rendu immédiat : le Spin de la liste couvre le chargement du store, de surrender et le calcul
    return (
      <ListEcartReddition
        tableOption={columns}
        locations={
          locations &&
          locations.filter((l) => l.location_etat === "r")
        }
        listData={
          proprietaires &&
          proprietaires.filter(
            (p) =>
              p.proprietaire_affectations.some(
                (ligne) =>
                  ligne.proprietaire_affectation_societe.societe_id === utilisateur.societe_id
              ) && p.proprietaire_personne.personne_actif === true
          )
        }
        quittances={quittances}
        reglements={reglements}
        ecritures={ecritures}
        report={report}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadProprietaires: () => dispatch(loadProprietaires()),
    loadLocations: () => dispatch(loadLocations()),
    loadQuittances: () => dispatch(loadQuittances()),
    loadReglements: () => dispatch(loadReglements()),
    loadEcritures: () => dispatch(loadEcritures()),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    proprietaires: state.proprietaires.data,
    locations: state.locations.data,
    quittances: state.quittances.data,
    reglements: state.reglements.data,
    ecritures: state.ecritures.data,
    report: state.ecritures.report,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EcartReddition);
